




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import {
  buildKandidatPenunjang,
  buildKandidatPenunjangLain,
  formatPenunjang,
  JenisPenunjang,
  KandidatPenunjang
} from "@/utils/klaimRehabMedik";

@Component
export default class DialogPilihPenunjang extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop() readonly register!: string | number;
  /**
   * Kosongkan untuk perilaku lama (lab + radiologi digabung). Isi dengan satu
   * jenis agar dialog hanya memuat & menampilkan jenis itu.
   */
  @Prop({ type: String, default: null }) readonly jenis!: JenisPenunjang | null;
  @Prop({ type: String, default: null }) readonly tujuan!: string | null;

  loading = false;
  kandidat: KandidatPenunjang[] = [];
  terpilih: string[] = [];

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.terpilih = [];
      this.muat();
    }
  }

  get labelTujuan(): string {
    if (this.tujuan) return this.tujuan;

    if (this.jenis === "lab") return "Laboratorium";
    if (this.jenis === "radiologi") return "Pemeriksaan Radiologi";
    if (this.jenis === "lain") return "Penunjang Lain";

    return "Pemeriksaan Penunjang";
  }

  get judulDialog(): string {
    if (this.jenis === "lab") return "Pilih Hasil Laboratorium";
    if (this.jenis === "radiologi") return "Pilih Hasil Radiologi";
    if (this.jenis === "lain") return "Pilih Penunjang Lain";

    return "Pilih Hasil Penunjang";
  }

  get labelTombol(): string {
    return "Tempel ke " + this.labelTujuan;
  }

  get teksKosong(): string {
    if (this.jenis === "lab") {
      return "Belum ada hasil laboratorium pada kunjungan ini.";
    }

    if (this.jenis === "radiologi") {
      return "Belum ada hasil radiologi pada kunjungan ini.";
    }

    if (this.jenis === "lain") {
      return "Belum ada penunjang lain pada kunjungan ini.";
    }

    return "Belum ada hasil laboratorium atau radiologi pada kunjungan ini.";
  }

  private perluJenis(j: JenisPenunjang): boolean {
    return this.jenis === null || this.jenis === j;
  }

  async muat() {
    const reg = this.register;
    if (!reg || this.loading) return;

    this.loading = true;
    this.kandidat = [];

    try {
      const [lab, radiologi, lain] = await Promise.all([
        this.perluJenis("lab")
          ? HasilPenunjangSvc.getLabByRegister(reg).catch(() => null)
          : Promise.resolve(null),
        this.perluJenis("radiologi")
          ? HasilPenunjangSvc.getRadiologiByRegister(reg).catch(() => null)
          : Promise.resolve(null),
        this.perluJenis("lain")
          ? HasilPenunjangSvc.getPenunjangLainByRegister(reg).catch(() => null)
          : Promise.resolve(null)
      ]);

      if (String(reg) !== String(this.register)) return;

      this.kandidat = buildKandidatPenunjang(
        (lab && lab.data) || [],
        (radiologi && radiologi.data) || []
      ).concat(
        buildKandidatPenunjangLain(
          lain && Array.isArray(lain.data) ? lain.data : []
        )
      );
    } finally {
      this.loading = false;
    }
  }

  tempel() {
    const dipilih = this.kandidat.filter(
      item => this.terpilih.indexOf(item.key) !== -1
    );

    this.$emit("apply", formatPenunjang(dipilih));
    this.tutup();
  }

  tutup() {
    this.$emit("input", false);
  }
}
